import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const AttributeAdd = () => {
  const navigate = useNavigate();
  const initialFormState = {
    attr_name: "",
    attr_value: "",
    status: "",
  };

  const [AttributeUser, setAttributeUser] = useState(initialFormState);

  const handleInput = (e) => {
    const { name, value } = e.target;
    setAttributeUser({ ...AttributeUser, [name]: value });
  };

  const submitForm = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/add_Attribute",
        AttributeUser
      );

      if (response.data.status === true) {
        toast.success(response.data.message || "Attribute added successfully!");
        navigate("/attribute-list");
      } else {
        toast.error(response.data.error || "Failed to add data");
      }
    } catch (error) {
      console.error("API Error:", error.response || error.message);
      toast.error("Something went wrong!");
    }
  };

  return (
    <div className="page-content">
      {/* Start Container Fluid */}
      <div className="container-fluid">
        {/* ========== Page Title Start ========== */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Attribute Add</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="javascript: void(0);">Attribute</a>
                </li>
                <li className="breadcrumb-item active">Attribute Add</li>
              </ol>
            </div>
          </div>
        </div>
        {/* ========== Page Title End ========== */}
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Add Attribute</h4>
              </div>
              <form onSubmit={submitForm}>
                <div className="card-body">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label
                          htmlFor="attr_name"
                          className="form-label text-dark"
                        >
                          Attribute Name
                        </label>
                        <input
                          type="text"
                          id="attr_name"
                          name="attr_name"
                          onChange={handleInput}
                          value={AttributeUser.attr_name}
                          className="form-control"
                          placeholder="Enter Name"
                        />
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label
                          htmlFor="attr_value"
                          className="form-label text-dark"
                        >
                          Attribute Value
                        </label>
                        <input
                          type="text"
                          id="attr_value"
                          name="attr_value"
                          onChange={handleInput}
                          value={AttributeUser.attr_value}
                          className="form-control"
                          placeholder="Enter Value"
                        />
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <label htmlFor="status" className="form-label">
                        Status
                      </label>
                      <select
                        className="form-control"
                        id="status"
                        name="status"
                        onChange={handleInput}
                        value={AttributeUser.status}
                        required
                      >
                        <option value="">-- Select Status --</option>
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="card-footer border-top">
                  <button type="submit" className="btn btn-primary">
                    Save Change
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* End Container Fluid */}
      {/* ========== Footer Start ========== */}
      <footer className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 text-center">
              © Venton. Crafted by{" "}
              <iconify-icon
                icon="iconamoon:heart-duotone"
                className="fs-18 align-middle text-danger"
              />{" "}
              <a href="" className="fw-bold footer-text" target="_blank">
                Techzaa
              </a>
            </div>
          </div>
        </div>
      </footer>
      {/* ========== Footer End ========== */}
    </div>
  );
};

export default AttributeAdd;
